
import { Dialog } from "vant";
import { addForm, editForm } from "@/service/form";
import _ from "lodash";
import {
    getKey,
    encrypt,
    rsaUtil,
    serverPublicKey,
  } from "@/common/js";
let genKeyPair = rsaUtil.genKeyPair();
window.jsPublicKey = genKeyPair.publicKey;
window.jsPrivateKey = genKeyPair.privateKey;

let goTo = () => {}, whiteList = [];

// form表单提交方法
export const onSubmit = (params) => {
    if(params.nav){
      goTo = params.nav
    }
    if(whiteList) {
      whiteList = params.white
    }
    Dialog.confirm({
      title: "提示",
      message: "你确定要提交吗？",
    })
      .then(() => {
        params.proxy.$showLoading();
        add(params);
      })
      .catch(() => {
        // on cancel
      });
  };
  const add = async (params) => {
    let data = {
      formId: params.formId,
      list: [],
    };
    let fn = addForm;
    if (params.type == 1) {
      data.id = params.id;
      fn = editForm;
    }
    let arr = [];
    if(params.values.form) {
      Object.keys(params.values.form).forEach(function (item) {
        let itemData = params.values.form[item]
        // 移除白名单内容 多余的数据
        itemData = _.map(itemData, o => _.omit(o, whiteList));
        let obj = {
          fieldCode: item,
          value: itemData,
        };
        if (itemData ||itemData  == 0) {
          arr.push(obj);
        }
      });
    } else {
      for (const item in params.values.form) {
        let obj = {
          fieldCode: item,
          value: params.values.form[item],
        };
        if (params.values[item] || params.values[item] == 0) {
          arr.push(obj);
        }
      }
    }
    data.list = arr;
    console.log('data ->', data)

    //随机获取AES的key
    let aesKey = getKey().toLowerCase();
    let param = {
      encryptData: encrypt(data, aesKey), //AES加密后的数据
      encrypted: rsaUtil.encrypt(aesKey, serverPublicKey), //后端RSA公钥加密后的AES的key
      // publicKey: window.jsPublicKey //前端公钥
    };
    try {
      const res = await fn(param);
      if (res.code === 10000) {
        Dialog.alert({
          message: "您提交的信息已提交审核，审核通过后将自动发布，请等待审核结果~",
        }).then(() => {
          params.proxy.$closeLoading();
          goTo();
        });
      } else {
        params.proxy.$closeLoading();
      }
    } catch (error) {
      params.proxy.$closeLoading();
    }
  };
 
